// @ts-strict-ignore
import { HttpClient } from '@angular/common/http';
import { ArticleManager } from '@article/manager/article.manager';
import { ProjectGroupVO } from '../../../model/vo/project-group.vo';
import { LocaleResourceManager } from '@shared/manager/locale-resource.manager';
import { ArticleObject3DManager } from '@article/manager/article-object-3d.manager';
import { DrillingHoleHelper } from '@3d-scene/model3d/util/drillinghole/drilling-hole.helper';
import { ProjectModel } from '../../../model/project.model';
import { ArticleUsageVO, ArticleVO } from '@article/model/vo/article.vo';
import { ProjectGroupDataService } from '../service/project-group-data.service';
import { ProjectGroupLoadingService } from '../../project/service/project-group-loading.service';
import { ProServeProjectImportUtils } from '../generator/pro-serve-project-import-utils';
import { ArticleUtils } from '@article/util/article-utils';
import { TextSizeCheckUtils } from '@shared/util/text-size-check-utils';
import { ProjectUtils } from '../../project/util/project-utils';
import { ParseProServeData } from '../../../processor/parse-pro-serve-data';
import { LabelingUtils } from '@3d-scene/model3d/util/labeling-utils';
import { ArticleUsageUtils } from '@article/util/article-usage-utils';
import { ArticleUsageInfoPropertyDef } from '@article/constants/article-usage-info-property-def';
import { PropertyValueVO, PropertyVO } from '../../article/model/vo/property.vo';
import { MountingRailArticlePostParseProcessor } from '../../article/processor/postparse/mounting-rail-post-parse.processor';
import { DrillingHoleInfo } from '@3d-scene/model3d/util/drillinghole/drilling-hole-info';
import { BlockingZoneArticleManager } from '../../article/manager/blocking-zone-article-manager';
import { OnRailReferenceArticleLocationVO } from '../../article/model/vo/on-rail-reference-article-location.vo';
import { StringUtils } from '@shared/util/string-utils';
import { ConnectionAreaVO, MetaElementUsageIdentityVO, MetaElementVO, TextureAreaUsageVO, TextureAreaVO } from '@shared/vo/meta-element.vo';
import { Connection } from '@3d-scene/model3d/connection';
import { SuitableConnectionAreasVO } from '../../article/model/vo/suitable-connection-areas.vo';
import { NumberUtils } from '@shared/util/number-utils';
import { ArticleCreationManager } from '../../article/manager/article-creation.manager';
import { ArticleContainer } from '@3d-scene/model3d/article-container';
import { ContainerService } from '@3d-scene/model3d/container.service';
import { TextureConnectionInfo } from '@3d-scene/model3d/texture-connection-info';
import { OrderConnectionInformationVO } from '../../article/model/vo/order-connection-information.vo';
import { ArticleConstants } from '@article/constants/article-constants';
import { ArticleTypeConstants } from '@article/constants/article-type-constants';
import { PropertyUtils } from '@article/util/property-utils';
import { MetaElementBehaviorPropertyDef } from '../../../constants/meta-element-behavior-property-def';
import { InitManager } from '@shared/manager/init.manager';
import { Dictionary } from 'typescript-collections';
import { TextSizeCheckManager } from '@3d-scene/manager/text-size-check.manager';
import { TextSizeCheckRequestVO } from '@3d-scene/manager/text-size-check.vo';
import { TextCheckSpacingData } from '@3d-scene/manager/text-check-spacing-data';
import { AlertHelper } from '@shared/alert/alert.helper';
import { ProjectOptionVO, UserInfoVO } from '../../../model/vo/project.vo';
import { OldArticleNumberMappingVO } from '@article/model/vo/old-article-number-mapping.vo';
import { ArrayUtils } from '@shared/util/array-utils';
import { PropertyParser } from '@shared/localization/property-parser';
import { ProjectGroupUtils } from '../../project/util/project-group-utils';
import { Log } from '@shared/debug/log';
import { ProjectNavigationModel } from '@project-navigation/project-navigation.model';
import { ArticleExportDataService } from '@article/service/article-export-data.service';
import { ArticleCreationManagerFactory } from '../../article/manager/article-creation.manager.factory';
import { BlockingZoneArticleManagerFactory } from '../../article/manager/blocking-zone-article-manager.factory';
import { InsertArticleService } from '../../article/service/insert-article.service';
import { SaveProjectService } from '../../project/project-save/save-project.service';
import { firstValueFrom, lastValueFrom, Subscription } from 'rxjs';
import { Injectable, OnDestroy } from '@angular/core';
import { InsertedArticleData } from '../../article/processor/i-article-location.processor';
import { LabelEditorData } from '../../label/label-editor/service/open-label-editor.service';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ArticleCreationService } from '../../article/service/article-creation.service';
import { ProjectModelService } from '@project/service/project-model.service';
import { ProjectArticleService } from '@project/service/project-article.service';
import { ProServeArticleManager } from '@article/manager/pro-serve-article.manager';
import { ProjectMetaElementService } from '@project/manager/project-meta-element.service';
import { ConnectionInfoUtils } from '@3d-scene/model3d/util/connection-info-utils';
import { AttachArticleUsageService } from '@project/service/attach-article-usage.service';
import { ArticleDataService } from '@article/service/article-data.service';
import { ConnectionInfoService } from '@3d-scene/model3d/service/connection-info.service';
import { ProjectComponentPresenter } from '../../project-component.presenter';
import { ProjectUserModel } from '../../../model/project-user.model';
import { ArticleNumberLong } from '../../../model/article-number-long';
import { IsProjectType } from '../../../model/is-project-type';
import { UserModel } from '@user/model/user.model';

@Injectable({ providedIn: 'root' })
export class ProServeProjectImportProcessor implements OnDestroy {
  private static ROOT: string = 'root';
  private static PROJECT_GROUP: string = 'ProjectGroup';
  private static PROJECT: string = 'Project';
  private static DRAWING: string = 'Drawing';
  private static PLANT: string = 'Plant';
  private static CARRIER: string = 'Carrier';
  private static LOCATION: string = 'Location';
  private static PROJECT_GROUP_NO: string = 'ProjectGroup_No';
  private static PROJECT_NO: string = 'Project_No';
  private static DRAWING_NO: string = 'Drawing_No';
  private static PLANT_NO: string = 'Plant_No';
  private static CARRIER_NO: string = 'Carrier_No';
  private static LOCATION_NO: string = 'Location_No';
  public static CORRECT_ARTICLE_POSTION: number = 10;

  private articleCreationManager: ArticleCreationManager;
  private blockingZoneManager: BlockingZoneArticleManager;

  private parentProjectGroup: ProjectGroupVO;
  private carriers: any[] = [];
  private currentChild: any[] = [];
  private projectArticleIdToRailPosData: any[] = [];
  private labelingMaterialCollection: any[] = [];
  private toDeleteLabel: any[] = [];
  private projectelementsData: any;
  private troubleTable: string[] = [];
  private carrierNo: string;
  private projectArticleID: string;
  private articleNo: string;
  private projectPorjectMetaData: string[] = [];
  private projectSummary: Dictionary<string, number> = new Dictionary<string, number>();
  private projectToGroupMapping: Dictionary<string, ProjectGroupVO> = new Dictionary<string, ProjectGroupVO>();
  private proServerModus: boolean;
  private convertedmappedArticleNoArrayToDictionary: OldArticleNumberMappingVO[] = [];
  private carrierCounter: number;
  private currentProjectArticleArray: ArticleVO[] = [];
  private holes: DrillingHoleInfo[];
  private productionConnectionWithSameArticleID: string[];
  private mountingRail: ArticleVO = null;
  private projectConnections: string[] = [];
  private projectConnectionAccessories: string[] = [];
  private projectArticleIdToArticleUsage: ArticleUsageVO[] = [];
  private mappingArticleArray: ArticleVO[] = [];
  private railPosToTextCheckSpacingData: number[] = [];
  private oldMountingRailArticleNumber: string;
  private mountingRailArticle: ArticleVO;
  private mountingRailArticleUsage: ArticleUsageVO;
  private globalToDeleteLabel: number[] = [];
  private maxLength: number;
  private productionConnection: string[] = [];
  private articlesForOneProject: string[] = [];
  private mappingArticleNo: string[] = [];
  private xmltoArray: string[] = [];
  private targetsOfBase: string[] = [];
  private projectConnectionCounterAcessories: number;
  private projectArticleIdToLabelUsage: ArticleUsageVO[] = [];
  private sendingHoles: boolean = false;
  private _waitImportPopupShown: boolean = false;
  private carrierName: string;
  private projectMetaData: Dictionary<string, string[]> = new Dictionary<string, string[]>();
  private labelAttribute: string[];
  private tagsByProjectArticleId: string[] = [];
  private alternativeorderNumbers: OrderConnectionInformationVO[] = [];
  private lastRequestedInsertProjectLabelIdForLabel: string;
  private interceptOpenLabelEditor: boolean = false;
  private _symbolfontToSmartfontCharMapping: any = null;
  private _initialized: boolean = false;
  private _articleInsertedSubscription: Subscription;
  private waitForImportPopupRef: BsModalRef;
  private _addedArticlesSubscription: Subscription;

  private alertHelper: AlertHelper;
  private httpClient: HttpClient
  private projectModel: ProjectModel;
  private projectModelService: ProjectModelService;
  private projectArticleService: ProjectArticleService;
  private projectMetaElementService: ProjectMetaElementService;
  private localeResourceManager: LocaleResourceManager;
  private articleManager: ArticleManager;
  private proServeArticleManager: ProServeArticleManager;
  private projectGroupDataService: ProjectGroupDataService;
  private drillingHoleHelper: DrillingHoleHelper;
  private articleObject3DManager: ArticleObject3DManager;
  private projectGroupLoadingService: ProjectGroupLoadingService;
  private textSizeCheckManager: TextSizeCheckManager;
  private saveProjectService: SaveProjectService;
  private articleExportDataService: ArticleExportDataService;
  private articleDataService: ArticleDataService;
  private articleCreationManagerFactory: ArticleCreationManagerFactory;
  private blockingZoneArticleManagerFactory: BlockingZoneArticleManagerFactory;
  private connectionInfoService: ConnectionInfoService;
  private containerService: ContainerService;
  private insertArticleService: InsertArticleService;
  private articleCreationService: ArticleCreationService;
  private attachArticleUsageService: AttachArticleUsageService;
  private _processorInitialized = false;
  private projectUserModel: ProjectUserModel;
  private userModel: UserModel;

  constructor(private projectComponentPresenter: ProjectComponentPresenter) {
  }

  public initialize(
    alertHelper: AlertHelper,
    httpClient: HttpClient,
    projectModel: ProjectModel,
    projectModelService: ProjectModelService,
    projectArticleService: ProjectArticleService,
    projectMetaElementService: ProjectMetaElementService,
    localeResourceManager: LocaleResourceManager,
    articleManager: ArticleManager,
    proServeArticleManager: ProServeArticleManager,
    projectGroupDataService: ProjectGroupDataService,
    drillingHoleHelper: DrillingHoleHelper,
    articleObject3DManager: ArticleObject3DManager,
    projectGroupLoadingService: ProjectGroupLoadingService,
    textSizeCheckManager: TextSizeCheckManager,
    saveProjectService: SaveProjectService,
    articleExportService: ArticleExportDataService,
    articleDataService: ArticleDataService,
    articleCreationManagerFactory: ArticleCreationManagerFactory,
    blockingZoneArticleManagerFactory: BlockingZoneArticleManagerFactory,
    connectionInfoService: ConnectionInfoService,
    containerService: ContainerService,
    insertArticleService: InsertArticleService,
    articleCreationService: ArticleCreationService,
    attachArticleUsageService: AttachArticleUsageService,
    projectUserModel: ProjectUserModel,
    userModel: UserModel,
  ) {
    this.alertHelper = alertHelper;
    this.httpClient = httpClient;
    this.projectModel = projectModel;
    this.projectModelService = projectModelService;
    this.projectArticleService = projectArticleService;
    this.projectMetaElementService = projectMetaElementService;
    this.localeResourceManager = localeResourceManager;
    this.articleManager = articleManager;
    this.proServeArticleManager = proServeArticleManager;
    this.projectGroupDataService = projectGroupDataService;
    this.drillingHoleHelper = drillingHoleHelper;
    this.articleObject3DManager = articleObject3DManager;
    this.projectGroupLoadingService = projectGroupLoadingService;
    this.textSizeCheckManager = textSizeCheckManager;
    this.saveProjectService = saveProjectService;
    this.articleExportDataService = articleExportService;
    this.articleDataService = articleDataService;
    this.articleCreationManagerFactory = articleCreationManagerFactory;
    this.blockingZoneArticleManagerFactory = blockingZoneArticleManagerFactory;
    this.connectionInfoService = connectionInfoService;
    this.containerService = containerService;
    this.insertArticleService = insertArticleService;
    this.articleCreationService = articleCreationService;
    this.attachArticleUsageService =  attachArticleUsageService;
    this.projectUserModel = projectUserModel;
    this.userModel = userModel;

    this._processorInitialized = true;

    this.subscribeOnAddedArticles();
  }

  public ngOnDestroy(): void {
    this.ensureInitialized();
    this._articleInsertedSubscription?.unsubscribe();
    this._articleInsertedSubscription = undefined;
    this._addedArticlesSubscription?.unsubscribe();
    this._addedArticlesSubscription = undefined;
  }

  private async loadSymbolfontToSmartfontCharMapping(): Promise<void> {
    const response: string = await firstValueFrom(this.httpClient.get('ng-assets/wago_symbolfont_to_smartfont_char_mapping.properties', {responseType: 'text'}));
    this._symbolfontToSmartfontCharMapping = PropertyParser.parse(response);
    if (this._initialized) {
      await this.startImportProcess();
    }
  }

  public async importProServeProject(data: any, currentlySelectedProjectGroup: ProjectGroupVO): Promise<void> {
    this.ensureInitialized();
    this.showWaitImportPopup();
    if (this._symbolfontToSmartfontCharMapping === null) {
      await this.loadSymbolfontToSmartfontCharMapping();
    }
    this.articleCreationManager = this.articleCreationManagerFactory.getNewInstance();
    this.articleCreationManager.showFaultMessage = false;
    this.blockingZoneManager = this.blockingZoneArticleManagerFactory.getNewInstance();
    this.carriers = [];
    this.proServerModus = true;
    this.projectModel.ignoreSplitConnectionCubes = true;
    this.projectModel.texturesEnabled = false;
    await this.projectModelService.clearCurrentProject();
    this.articleObject3DManager.clearAllCaches();
    this.projectSummary = new Dictionary<string, number>();
    if (currentlySelectedProjectGroup && currentlySelectedProjectGroup.id !== ProjectNavigationModel.ROOT_USER_ID) {
      this.parentProjectGroup = currentlySelectedProjectGroup;
    } else {
      this.parentProjectGroup = new ProjectGroupVO();
      this.parentProjectGroup.groupName = ProServeProjectImportProcessor.ROOT;
      this.parentProjectGroup.groupOwner = new UserInfoVO(this.userModel.user.id, this.userModel.user.login);
      this.parentProjectGroup.id = ProjectGroupVO.ROOT_GROUP_DUMMY_ID;
      this.parentProjectGroup.parentGroup = null;
    }
    this.processCarrierTag(data, this.parentProjectGroup);
    this.processProjectGroupStructure(this.parentProjectGroup);

    try {
      await firstValueFrom(this.projectGroupDataService.saveProjectGroupTree(this.parentProjectGroup));
      await this.saveGroup_success();
    } catch (error) {
      Log.error('Could not save group: ', error);
      this.saveGroup_failed();
    }

    await this.mountingRailArticleContainerAttached();

    for (let projectConnection of this.projectConnections) {
      await this.continueMountingRailArticleContainerAttached(projectConnection);
    }
    for(let projectConnectionAccessory of this.projectConnectionAccessories) {
      await this.continueArticleContainerAttached(projectConnectionAccessory);
    }
    await this.preProcessLabels();
    await this.setLabels();
  }

  private saveGroup_failed(): void {
    if (this.proServerModus) {
      this.alertHelper.showError('save.title.error_saving_projectGroup', 'save.message.error_saving_projectGroup');
    }
  }

  private async saveGroup_success(): Promise<void> {
    if (this.proServerModus) {
      this._initialized = true;
      if (this._symbolfontToSmartfontCharMapping !== null) {
        await this.startImportProcess();
      }
    }
  }

  private async startImportProcess(): Promise<void> {
    this.carrierCounter = 0;
    await this.startLoadCarrier(this.carrierCounter);
  }

  private processCarrierTag(xml: Document, parentGroup: ProjectGroupVO): ProjectGroupVO {
    const childrenOfCurrentNode: any = xml.childNodes;
    let childName: string;
    let childGroup: ProjectGroupVO = new ProjectGroupVO();
    let isTagFound: boolean;
    for (const childTag of childrenOfCurrentNode) {
      childName = '';
      let metaDataKey: string;
      if (childTag) {
        isTagFound = true;
        switch (childTag.localName) {
          case ProServeProjectImportProcessor.PROJECT_GROUP:
            childName = childTag.attributes[ProServeProjectImportProcessor.PROJECT_GROUP_NO].value;
            metaDataKey = 'ProjectGroup';
            break;
          case ProServeProjectImportProcessor.DRAWING:
            childName = childTag.attributes[ProServeProjectImportProcessor.DRAWING_NO].value;
            metaDataKey = 'Drawing';
            break;
          case ProServeProjectImportProcessor.PLANT:
            childName = childTag.attributes[ProServeProjectImportProcessor.PLANT_NO].value;
            metaDataKey = 'Plant';
            break;
          case ProServeProjectImportProcessor.LOCATION:
            childName = childTag.attributes[ProServeProjectImportProcessor.LOCATION_NO].value;
            metaDataKey = 'Location';
            break;
          case ProServeProjectImportProcessor.PROJECT:
            childName = childTag.attributes[ProServeProjectImportProcessor.PROJECT_NO].value;
            metaDataKey = 'Project';
            break;
          case ProServeProjectImportProcessor.CARRIER:
            const tempArray: any[] = [];
            const carrierUUID: string = StringUtils.createUuid();
            this.projectToGroupMapping.setValue(carrierUUID, parentGroup);
            const currentMeta = this.clone(this.projectPorjectMetaData);
            tempArray.push(childTag);
            tempArray.push(carrierUUID);
            tempArray.push(StringUtils.sanitizeProjectName(childTag.attributes[ProServeProjectImportProcessor.CARRIER_NO].value));
            tempArray.push(currentMeta);
            tempArray.push(carrierUUID);
            this.carriers.push(tempArray);
            break;
          default:
            isTagFound = false;
            break;
        }

        childName = StringUtils.sanitizeProjectName(childName);
        if (metaDataKey) {
          this.projectPorjectMetaData[metaDataKey] = childName;
        }

        if (isTagFound && childName !== '') {
          childGroup = this.createSubGroup(childName, parentGroup);
          this.processCarrierTag(childTag, childGroup);
        }
      }
    }
    return childGroup;
  }

  private processProjectGroupStructure(rootGroup: ProjectGroupVO): void {
    if (ArrayUtils.isEmpty(this.carriers)) {
      return;
    }
    const groups: ProjectGroupVO[] = rootGroup.groups;
    if (ArrayUtils.isNotEmpty(groups)) {
      for (const group of groups) {
        this.convertProjectGroupTree(group, false);
      }
    }
    this.convertProjectGroupTree(rootGroup, true);
    this.createUniqueNames(rootGroup, true);
    this.updateCarrierData();
  }

  private createUniqueNames(group: ProjectGroupVO, isRoot: boolean): void {
    if (ArrayUtils.isNotEmpty(group.groups)) {
      for (const childGroup of group.groups) {
        if (ProjectGroupUtils.isNewProjectGroup(childGroup)) {
          const names: string[] = this.getGroupNames(childGroup, group.groups);
          const oldName: string = childGroup.groupName;
          childGroup.groupName = this.createUniqueName(childGroup.groupName, names);
          if (isRoot && oldName !== childGroup.groupName) {
            for (const carrier of this.carriers) {
              const metaData: any = carrier[3];
              this.replaceProjectGroupTagValue(metaData, childGroup.groupName);
              this.replaceProjectGroupTagValue(this.projectPorjectMetaData, childGroup.groupName);
            }
          }
          this.createUniqueNames(childGroup, false);
        }
      }
    }
  }

  private replaceProjectGroupTagValue(metaData: any, value: string): void {
    if (metaData.hasOwnProperty('ProjectGroup') && metaData['ProjectGroup']) {
      metaData['ProjectGroup'] = value;
    }
  }

  private getGroupNames(currentGroup: ProjectGroupVO, projectGroups: ProjectGroupVO[]): string[] {
    const groupNameList: string[] = [];
    for (const projectGroup of projectGroups) {
      if (currentGroup !== projectGroup) {
        groupNameList.push(projectGroup.groupName);
      }
    }
    return groupNameList;
  }

  private createUniqueName(groupName: string, namesToCheck: string[]): string {
    let isUnique: boolean = namesToCheck.indexOf(groupName) === -1;
    let count: number = 1;
    let uniqueName: string = groupName;
    while (!isUnique) {
      uniqueName = `${groupName}_${count}`;
      isUnique = namesToCheck.indexOf(uniqueName) === -1;
      count++;
    }
    return uniqueName;
  }

  private updateCarrierData(): void {
    if (ArrayUtils.isEmpty(this.carriers)) {
      return;
    }
    for (const carrier of this.carriers) {
      const carrierUUID: string = carrier[1];
      const projectGroup: ProjectGroupVO = this.projectToGroupMapping.getValue(carrierUUID);
      carrier[1] = projectGroup;
    }
  }

  private isConversionToProjectRequired(group: ProjectGroupVO): boolean {
    const carriers: any[] = this.findCarriersForProjectGroup(group);
    return ArrayUtils.isNotEmpty(carriers);
  }

  private convertProjectGroupTree(group: ProjectGroupVO, isExistingGroup: boolean): void {
    const groups: ProjectGroupVO[] = group.groups;
    if (ArrayUtils.isNotEmpty(groups) && !isExistingGroup) {
      for (const group of groups) {
        this.convertProjectGroupTree(group, false);
      }
    }
    if (this.isConversionToProjectRequired(group)) {
      if (this.isNewProjectGroupRequired(group) || isExistingGroup) {
        const createdGroup: ProjectGroupVO = this.createSubGroup(group.groupName, group, true);
        this.updateCarrierLocation(group, createdGroup);
      } else {
        group.groupType = ProjectGroupUtils.PROJECT;
      }
    }
  }

  private updateCarrierLocation(fromGroup: ProjectGroupVO, toGroup: ProjectGroupVO): void {
    const carrierUUIDs: string[] = [];
    this.projectToGroupMapping.forEach((carrierUUID: string, projectGroup: ProjectGroupVO) => {
      if (projectGroup === fromGroup) {
        carrierUUIDs.push(carrierUUID);
      }
    });
    for (const carrierUUID of carrierUUIDs) {
      this.projectToGroupMapping.setValue(carrierUUID, toGroup);
    }
  }

  private isNewProjectGroupRequired(group: ProjectGroupVO): boolean {
    const carriers: any[] = this.findCarriersForProjectGroup(group);
    if (ArrayUtils.isEmpty(carriers)) {
      return false;
    }
    const childGroups: ProjectGroupVO[] = group.groups;
    if (ArrayUtils.isEmpty(childGroups)) {
      return false;
    }
    const newProjectGroups: ProjectGroupVO[] = childGroups.filter((projectGroup: ProjectGroupVO) =>
      ProjectGroupUtils.isNewProjectGroup(projectGroup)
    );
    if (ArrayUtils.isEmpty(newProjectGroups)) {
      return false;
    }
    return true;
  }

  private findCarriersForProjectGroup(group: ProjectGroupVO): any[] {
    const carriers: any[] = [];
    for (const groupUUID of this.projectToGroupMapping.keys()) {
      const projectGroup: ProjectGroupVO = this.projectToGroupMapping.getValue(groupUUID);
      if (group === projectGroup) {
        for (const carrier of this.carriers) {
          if (groupUUID === carrier[1]) {
            carriers.push(carrier);
          }
        }
      }
    }
    return carriers;
  }

  private clone(original: any): string[] {
    const cloned: any[] = [];
    for (const key in original) {
      if (original.hasOwnProperty(key)) {
        if (original[key] instanceof String) {
          cloned[key] = this.clone(original[key]);
        } else {
          cloned[key] = original[key];
        }
      }
    }
    return cloned;
  }

  private createSubGroup(pgName: string, parentGroup: ProjectGroupVO, isConfigurationGroup: boolean = false): ProjectGroupVO {
    const projectGroup: ProjectGroupVO = new ProjectGroupVO();
    projectGroup.id = -1;
    projectGroup.guid = StringUtils.createUuid();
    projectGroup.groupName = pgName;
    projectGroup.groupOwner = new UserInfoVO(parentGroup ? parentGroup.groupOwner.userId : this.userModel.user.id);
    if (parentGroup) {
      if (!parentGroup.groups) {
        parentGroup.groups = [];
      }
      parentGroup.groups.push(projectGroup);
    }
    if (isConfigurationGroup) {
      projectGroup.groupType = ProjectGroupUtils.PROJECT;
    }
    return projectGroup;
  }

  private async startLoadCarrier(counter: number): Promise<void> {
    this.interceptOpenLabelEditor = true;
    this.currentChild = this.carriers[counter];
    this.sendingHoles = true;
    this.projectConnectionAccessories = [];
    this.projectConnectionCounterAcessories = 0;
    const currentChildXML: Document = this.currentChild[0];
    this.carrierName = this.currentChild[2];
    this.projectPorjectMetaData['Carrier'] = this.currentChild[2];
    this.carrierNo = this.currentChild[2];
    this.projectSummary.setValue(this.currentChild[4], 1);
    this.proServerModus = true;
    this.projectModel.ignoreSplitConnectionCubes = true;
    this.projectModel.texturesEnabled = false;
    await this.getCarrierProducts(currentChildXML);
  }

  private async getCarrierProducts(xml: Document): Promise<void> {
    if (xml) {
      this.projectelementsData = ProServeProjectImportUtils.parseProjectMetaelement(xml, this.carrierNo);
      if (this.projectelementsData) {
        this.projectMetaData = this.projectelementsData.metaElemnts;
        this.projectMetaData['Project'] = this.projectPorjectMetaData;
        const parsedXMLData: ParseProServeData = ProServeProjectImportUtils.parseXMLData(xml, this._symbolfontToSmartfontCharMapping);
        this.productionConnection = parsedXMLData.productionConnection;
        this.articlesForOneProject = parsedXMLData.articlesForOneProject;
        this.mappingArticleNo = parsedXMLData.mappingArticleNo;
        this.holes = parsedXMLData.holes;
        this.xmltoArray = parsedXMLData.xmltoArray;
        this.productionConnectionWithSameArticleID = parsedXMLData.productionConnectionWithSameArticleID;
        this.tagsByProjectArticleId = parsedXMLData.tagsByProjectArticleId;
        this.labelAttribute = parsedXMLData._labelAttribute;
        const sortedArray: string[] = ProServeProjectImportUtils.sortDictionaryInArray(this.productionConnection);
        this.projectConnections = sortedArray;
        await this.getArticleNumberMappingsByOldArticleNumbers(ProServeProjectImportUtils.uniqueArray(this.articlesForOneProject));
      }
    }
  }

  private async getArticleNumberMappingsByOldArticleNumbers(oldArticleNumbers: string[]): Promise<void> {
    if (ArrayUtils.isEmpty(oldArticleNumbers)) {
      await this.newArticleNumberRetrievedFailure();
    }
    try {
      const parsedData: OldArticleNumberMappingVO[] = await this.articleDataService.getArticleNumberMappingsByOldArticleNumbers(oldArticleNumbers).toPromise();
      await this.newArticleNumberRetrievedSuccess(parsedData)
    } catch (error) {
      Log.error('Could not get article number mapping: ', error)
      await this.newArticleNumberRetrievedFailure()
    }
  }

  private async newArticleNumberRetrievedSuccess(data: OldArticleNumberMappingVO[]): Promise<void> {
    if (this.proServerModus) {
      this.convertedmappedArticleNoArrayToDictionary = ProServeProjectImportUtils.convertmappedArticleNoArrayToDictionary(data);
      this.mappingArticleNo =
        ProServeProjectImportUtils.replaceOldArticleNumbersWithMappedArticleNumbers(this.mappingArticleNo, this.convertedmappedArticleNoArrayToDictionary);
      const articles = await this.proServeArticleManager.retrieveArticlesByArticleNumbers(
      ProServeProjectImportUtils.uniqueArray(ProServeProjectImportUtils.replaceOldArticleNumbersArrayWithMappedArticleNumbers(
        this.articlesForOneProject, ProServeProjectImportUtils.convertmappedArticleNoArrayToDictionary(data))));
      await this.articlesRetrievedSuccess(articles);
    }
  }

  private async newArticleNumberRetrievedFailure(): Promise<void> {
    if (this.proServerModus) {
      const articles = await this.proServeArticleManager.retrieveArticlesByArticleNumbers(this.articlesForOneProject);
      await this.articlesRetrievedSuccess(articles);
    }
  }

  private async articlesRetrievedSuccess(data: ArticleVO[]): Promise<void> {
    if (this.proServerModus) {
      const existsArticle: ArticleVO[] = [];
      const retrievedData: ArticleVO[] = data;
      const allArticle: ArticleVO[] = retrievedData.concat(existsArticle);
      if (allArticle) {
        await this.mappingArticleByArticleNumber(allArticle);
      }
    }
  }

  private async mappingArticleByArticleNumber(articlesForOneProject: ArticleVO[]): Promise<void> {
    const mappingArticle: ArticleVO[] = [];
    this.currentProjectArticleArray = [];
    let textSizeCheckRequests: TextSizeCheckRequestVO[] = [];
    let textCheckClasses: string[] = [];
    for (const item of articlesForOneProject) {
      if (item) {
        mappingArticle[item.articleNo] = item;
        this.currentProjectArticleArray.push(item);
      }
      if (ArticleUtils.isLabelingArticle(item)) {
        const classes: string[] = TextSizeCheckUtils.getTextCheckClassesByLabelingArticle(item);
        textCheckClasses = textCheckClasses.concat(classes);
      }
    }
    for (const item of articlesForOneProject) {
      if (!ArticleUtils.isLabelingArticle(item) && this.textSizeCheckManager) {
        const requests: TextSizeCheckRequestVO[] = this.textSizeCheckManager.getTextSizeCheckRequestsByTerminalArticleAndTextCheckClasses(
          item,
          textCheckClasses
        );
        if (requests && requests.length > 0) {
          textSizeCheckRequests = textSizeCheckRequests.concat(requests);
        }
      }
    }
    for (const textCheckClass of textCheckClasses) {
      const rq: TextSizeCheckRequestVO = new TextSizeCheckRequestVO();
      rq.textSizeCheckClass = textCheckClass;
      textSizeCheckRequests.push(rq);
    }
    this.mappingArticleArray = mappingArticle;
    if (textSizeCheckRequests.length > 0 && this.textSizeCheckManager) {
      if (await this.textSizeCheckManager.retrieveTextSizeCheckInfos(textSizeCheckRequests)) {
        await this.handleTextSizeCheckManagerRetrieval();
      } else {
        await this.handleTextSizeCheckManagerFailure();
      }
    } else {
      await this.setProjectType(this.currentProjectArticleArray);
    }
  }

  private async handleTextSizeCheckManagerRetrieval(): Promise<void> {
    if (this.proServerModus) {
      await this.setProjectType(this.currentProjectArticleArray);
    }
  }

  private async handleTextSizeCheckManagerFailure(): Promise<void> {
    this.ensureInitialized();
    if (this.proServerModus) {
      this.addTroubleArticle(this.currentChild[4], this.localeResourceManager.getValueByKey('validation.error.no_valid_config'), '0');
      await this.setProjectType(this.currentProjectArticleArray);
    }
  }

  private async setProjectType(articlesForOneProject: ArticleVO[]): Promise<void> {
    this.buildGlobalToDeleteLabel();
    for (const item of articlesForOneProject) {
      const isMountingRail: boolean = ArticleUtils.isMountingRail(item);
      if (isMountingRail) {
        this.mountingRail = item;
        break;
      }
    }
    if (this.mountingRail) {
      const oldMountingRailNumber: string = ProServeProjectImportUtils.getOldMountingRailNumber(
        this.mountingRail.articleNo,
        this.convertedmappedArticleNoArrayToDictionary
      );
      let projectType = ProServeProjectImportUtils.findProjectType(oldMountingRailNumber);
      if (projectType === "MOUNTING_RAIL") {
        const adjustedProjectType = ProjectUtils.getProjectTypeByMountingRailArticle(this.mountingRail);
        if (adjustedProjectType) {
          projectType = adjustedProjectType;
        }
      }
      this.projectModelService.currentProjectType = projectType;
      await this.loadMountingRail(oldMountingRailNumber);
    } else {
      this.proServerModus = false;
      this.projectModel.ignoreSplitConnectionCubes = false;
      this.projectModel.texturesEnabled = true;
      const mountingRailArticleNumber: string = ProServeProjectImportUtils.getMountingRailArticleNobyNoExistArticleVO(
        this.articlesForOneProject,
        articlesForOneProject
      );
      const articleInformation: string[] = this.xmltoArray;
      const mountingRailObject: any =
        articleInformation[
          ProServeProjectImportUtils.getOldMountingRailNumber(mountingRailArticleNumber, this.convertedmappedArticleNoArrayToDictionary)
        ];
      this.addTroubleArticle(this.currentChild[4], mountingRailArticleNumber, mountingRailObject.articleID);
      await this.proceedToNextCarrier();
    }
  }

  private buildGlobalToDeleteLabel(): void {
    this.projectArticleIdToRailPosData = [];
    this.railPosToTextCheckSpacingData = [];
    this.globalToDeleteLabel = [];
    let projectConnections: string[] = this.projectConnections;
    if (!projectConnections) {
      return;
    }
    projectConnections = projectConnections.concat();
    projectConnections = projectConnections.reverse();
    const mappingArticleNumber: string[] = this.mappingArticleNo;
    let posOnRail: number = 1;
    for (const projectConnection of projectConnections) {
      if (projectConnection && projectConnection['base-pin']) {
        const basePin: any = projectConnection['base-pin'];
        const targetPin: any = projectConnection['target-pin'];
        const getBasePinArticleNo = mappingArticleNumber[basePin.projectArticleID];
        const getTargetPinArticleNo = mappingArticleNumber[targetPin.projectArticleID];
        const mappingArticle: ArticleVO[] = this.mappingArticleArray;
        const article: ArticleVO = mappingArticle[getTargetPinArticleNo];
        const targetIsMountingRail: boolean = ArticleUtils.isMountingRail(article);
        if (targetIsMountingRail) {
          const articleToAttach: ArticleVO = mappingArticle[getBasePinArticleNo];
          if (articleToAttach) {
            if (ArticleUtils.isEndPlateArticleType(articleToAttach.type.displayName)) {
              this.globalToDeleteLabel.push(posOnRail);
            }
            const posData: any = new Object();
            posData.railPos = posOnRail;
            posData.textCheckSpacingData = LabelingUtils.getTextCheckSpacingDataByTerminalArticle(articleToAttach);
            this.projectArticleIdToRailPosData[basePin.projectArticleID] = posData;
            this.railPosToTextCheckSpacingData[posOnRail] = posData.textCheckSpacingData;
            posOnRail++;
          }
        }
      }
    }
  }

  private async loadMountingRail(oldMountingRailArticleNumber: string): Promise<void> {
    this.oldMountingRailArticleNumber = oldMountingRailArticleNumber;
    this.mountingRailArticle = this.articleManager.getCachedArticleByArticleNo(this.mountingRail.articleNo);
    this.mountingRailArticleUsage = this.projectArticleService.createNewArticleUsage(this.mountingRailArticle.identity, this.mountingRailArticle.version);
    if (IsProjectType.among(this.projectModel.currentProjectType, "FREE_MOUNTING", "SPEEDWAY", "CIRCUIT_BOARD")) {
      ArticleUsageUtils.setArticleUsageInfoPropertyFloatValue(
        this.mountingRailArticleUsage,
        ArticleUsageInfoPropertyDef.ARTICLE_LENGTH,
        MountingRailArticlePostParseProcessor.MAX_LENGTH
      );
    } else {
      ArticleUsageUtils.setArticleUsageInfoPropertyFloatValue(
        this.mountingRailArticleUsage,
        ArticleUsageInfoPropertyDef.ARTICLE_LENGTH,
        this.xmltoArray[oldMountingRailArticleNumber].length * ProServeProjectImportProcessor.CORRECT_ARTICLE_POSTION
      );
    }
    this.getMountingRailMaxLength();
    await this.attachArticleUsageService.attachArticleUsageToProject(this.mountingRailArticleUsage);
  }

  private getMountingRailMaxLength(): void {
    const behaviourProperties: PropertyVO[] = this.mountingRailArticle.behaviorProperties;
    for (const itemBehaviour of behaviourProperties) {
      if (itemBehaviour instanceof PropertyVO) {
        if (itemBehaviour.name === 'maxLength') {
          const values: PropertyValueVO[] = itemBehaviour.values;
          for (const value of values) {
            const maxLength: number = Number(value.intValue);
            this.maxLength = maxLength;
          }
        }
      }
    }
  }

  private addTroubleArticle(carrierUUID: string, articleNumber: string, projectArticleId: string): void {
    const troubleArticle: any = new Object();
    troubleArticle.carrierNo = carrierUUID;
    troubleArticle.articleNo = articleNumber;
    troubleArticle.projectArticleId = projectArticleId;
    this.troubleTable.push(troubleArticle);
    this.projectSummary.setValue(carrierUUID, 0);
  }

  private async proceedToNextCarrier(): Promise<void> {
    this.carrierCounter++;
    if (this.carrierCounter < this.carriers.length) {
      this.clearForNextCarrier();
      const carrier: number = this.carrierCounter;
      await this.projectModelService.clearCurrentProject(false);
      await this.startLoadCarrier(carrier);
    } else {
      if (this.projectelementsData) {
        this.closeWaitImportPopup();
        const summary: Dictionary<string, { projectName: string; state: number }> = new Dictionary();
        for (const carrier of this.carriers) {
          summary.setValue(carrier[4], { projectName: carrier[2], state: this.projectSummary.getValue(carrier[4]) });
        }
        await this.clear();
      }
    }
  }

  private async mountingRailArticleContainerAttached(): Promise<void> {
    this.ensureInitialized();
    if (this.proServerModus) {
      let filterdHoles: DrillingHoleInfo[] = [];
      const holes: DrillingHoleInfo[] = this.holes;
      const xmlToArray: string[] = this.xmltoArray;
      const oldMountingRailArticleNumber: string = this.oldMountingRailArticleNumber;
      if (xmlToArray[oldMountingRailArticleNumber]) {
        const moutingRailLength = xmlToArray[oldMountingRailArticleNumber].length * ProServeProjectImportProcessor.CORRECT_ARTICLE_POSTION;
        filterdHoles = ProServeProjectImportUtils.filterDrillingHolesByLengthOfMountingRail(holes, moutingRailLength);
        this.projectModel.existingProjectMountingRail();
        await this.drillingHoleHelper.addDrillingHoles(this.mountingRailArticleUsage, this.mountingRailArticle, this.articleManager, filterdHoles);
      }
    }
  }

  public async drillingHoleLoaded(): Promise<void> {
    this.ensureInitialized();
    if (this.proServerModus && this.sendingHoles) {
      this.sendingHoles = false;
      await this.insertBlockingZone(true);
    }
  }

  public async drillingHoleNOTLoaded(): Promise<void> {
    this.ensureInitialized();
    if (this.proServerModus && this.sendingHoles) {
      this.sendingHoles = false;
      await this.insertBlockingZone(true);
    }
  }

  private async insertBlockingZone(startZone: boolean): Promise<void> {
    let actionStarted: boolean = false;
    if (this.mountingRail) {
      const xmlToArray = this.xmltoArray;
      const articleNo: string = this.mountingRail.articleNo;
      const ts: any = xmlToArray[articleNo];
      if (ts) {
        const mappingArticle = this.mappingArticleArray;
        const articleToInsert: ArticleVO = mappingArticle['BlockingZone'];
        if (startZone) {
          if (!isNaN(ts.marginLow) && ts.marginLow > 0) {
            try {
              actionStarted = true;
              const data = await this.blockingZoneManager.insertZoneArticle(articleToInsert, this.mountingRailArticleUsage, ts.marginLow * 10, 0, true, false, 'insertStartBlockingZoneDuringImport');
              await this.startBlockingZoneInserted(data);
            } catch (error) {
              Log.error('Could not insert zone article: ', error);
              await this.startBlockingZoneFailure();
            }
          }
        } else {
          if (!isNaN(ts.marginHigh) && ts.marginHigh > 0) {
            try {
              actionStarted = true;
              const data = await this.blockingZoneManager.insertZoneArticle(articleToInsert, this.mountingRailArticleUsage, ts.marginHigh * 10, (ts.length - ts.marginHigh) * 10, true, false, 'insertEndBlockingZoneDuringImport');
              await this.endBlockingZoneInserted(data);
            } catch (error) {
              Log.error('Could not insert zone article: ', error);
              await this.endBlockingZoneFailure();
            }
          }
        }
      }
    }
    if (!actionStarted) {
      if (startZone) {
        await this.insertBlockingZone(false);
      } else {
        await this.findTargetMetaElements();
      }
    }
  }

  private async findTargetMetaElements(): Promise<void> {
    const getProjectConnection: any[] = this.projectConnections;
    const orderConnectionInformationVOArray: OrderConnectionInformationVO[] = [];
    const projectConnectionsWithSameArticleIdArray: any[] = [];
    if (ArrayUtils.isNotEmpty(this.productionConnectionWithSameArticleID)) {
      for (const value of this.productionConnectionWithSameArticleID) {
        if (value) {
          for (const val of value) {
            projectConnectionsWithSameArticleIdArray.push(val);
          }
        }
      }
    }
    const projectConnections: any = !getProjectConnection
      ? projectConnectionsWithSameArticleIdArray
      : getProjectConnection.concat(projectConnectionsWithSameArticleIdArray);
    for (const projectConnection of projectConnections) {
      if (!projectConnection['base-pin']) {
        continue;
      }
      const targetOrderConnectionInformation: OrderConnectionInformationVO = this.buildOptionalOrderConnectionInformationVO(
        projectConnection['target-pin'],
        this.mappingArticleNo,
        this.mappingArticleArray
      );
      if (targetOrderConnectionInformation) {
        orderConnectionInformationVOArray.push(targetOrderConnectionInformation);
      }
      const baseOrderConnectionInformation: OrderConnectionInformationVO = this.buildOptionalOrderConnectionInformationVO(
        projectConnection['base-pin'],
        this.mappingArticleNo,
        this.mappingArticleArray
      );
      if (baseOrderConnectionInformation) {
        orderConnectionInformationVOArray.push(baseOrderConnectionInformation);
      }
    }
    if (orderConnectionInformationVOArray.length > 0) {
      await this.getAlternativeOrderNumberInternal(orderConnectionInformationVOArray);
    }
  }

  private async getAlternativeOrderNumberInternal(retrieveAlternativeOrderNumbers: OrderConnectionInformationVO[]): Promise<void> {
    if (retrieveAlternativeOrderNumbers.length < 1) {
    }
    try {
      const articleList: OrderConnectionInformationVO[] = await lastValueFrom(this.articleExportDataService.getAlternativeOrderNumber(retrieveAlternativeOrderNumbers));
      await this.detectAlternativeOrderConnectionSuccessHandler(articleList);
    } catch (error) {
      Log.error(error);
    }
  }

  private buildOptionalOrderConnectionInformationVO(pin: any, articleNumberDictionary: any, articleVODictionary: any): OrderConnectionInformationVO {
    if (!pin || !articleNumberDictionary || !articleVODictionary) {
      return null;
    }
    const articleNo: string = articleNumberDictionary[pin.projectArticleID];
    const article: ArticleVO = articleVODictionary[articleNo];
    if (article && !ArticleUtils.isMountingRail(article)) {
      const metaElementName: string = ProServeProjectImportUtils.getMetaElementName(article.metaElements, pin.order);
      if (metaElementName === '') {
        const orderConnectionInformation: OrderConnectionInformationVO = new OrderConnectionInformationVO();
        orderConnectionInformation.articleNumber = articleNo;
        orderConnectionInformation.orderNumber = Number(pin.order);
        return orderConnectionInformation;
      }
    }
    return null;
  }

  private async importProServeProjectProcess_success(data: InsertedArticleData): Promise<void> {
    if (this.proServerModus) {
      const lastRequestedInsertProjectArticleId: string = data.articleLocation.data['lastRequestedInsertProjectArticleId'];
      this.projectArticleIdToArticleUsage[lastRequestedInsertProjectArticleId] = this.projectModel.getArticleUsage(data.insertedArticleGUIDs[0]);
    }
  }

  private async continueMountingRailArticleContainerAttached(projectConnection: string): Promise<void> {
    const mappingArticleNumber: string[] = this.mappingArticleNo;
    if (projectConnection && projectConnection['base-pin']) {
      const basePin: any = projectConnection['base-pin'];
      const targetPin: any = projectConnection['target-pin'];
      const getBasePinArticleNo = mappingArticleNumber[basePin.projectArticleID];
      const getTargetPinArticleNo = mappingArticleNumber[targetPin.projectArticleID];
      this.projectArticleID = basePin.projectArticleID;
      const mappingArticle: ArticleVO[] = this.mappingArticleArray;
      const article: ArticleVO = mappingArticle[getTargetPinArticleNo];
      const targetIsMountingRail: boolean = ArticleUtils.isMountingRail(article);
      if (targetIsMountingRail) {
        const articleToAttach: ArticleVO = mappingArticle[getBasePinArticleNo];
        if (articleToAttach) {
          const tsarticleNo: string = this.oldMountingRailArticleNumber;
          const tsarticleLength: number = this.convertedmappedArticleNoArrayToDictionary[tsarticleNo]
            ? this.convertedmappedArticleNoArrayToDictionary[tsarticleNo].articleLength
            : -1;
          this.articleNo = getBasePinArticleNo;
          const onRailArticleLocation: OnRailReferenceArticleLocationVO = new OnRailReferenceArticleLocationVO();
          const xmlToArray: string[] = this.xmltoArray;
          const ts: Object = xmlToArray[tsarticleNo];
          const lengthOfTS: number = Number(ts['length']);
          onRailArticleLocation.rangeOnLineArticleUsage = this.mountingRailArticleUsage;
          const maxLength: number = this.maxLength;
          if (tsarticleLength !== -1) {
            onRailArticleLocation.articleOffset = Number(targetPin.offset * tsarticleLength * 10);
          } else if (maxLength !== 0) {
            onRailArticleLocation.articleOffset = Number(targetPin.offset * maxLength * 10);
          } else {
            onRailArticleLocation.articleOffset = Number(targetPin.offset * lengthOfTS * 10);
          }
          onRailArticleLocation.offsetReferencesMiddlePoint = true;
          if (StringUtils.parseBoolean(basePin.turned)) {
            onRailArticleLocation.rotationAngle = 180;
          }
          onRailArticleLocation.data['lastRequestedInsertProjectArticleId'] = basePin.projectArticleID;

          try {
            const data = await this.insertArticleService.insertArticleByArticleLocation(articleToAttach, onRailArticleLocation, 'importProServeProjectProcess');
            await this.importProServeProjectProcess_success(data);
          } catch (error) {
            Log.error('Could not load article: ', error)
            await this.articleNOTProjected();
          }
        } else {
          this.addTroubleArticle(this.currentChild[4], getBasePinArticleNo, this.projectArticleID);
        }
      } else {
        const projectConnectionAccessories: string[] = this.projectConnectionAccessories;
        projectConnectionAccessories.push(projectConnection);
      }
    } else {
      const mappingArticle: ArticleVO[] = this.mappingArticleArray;
      const articleToInsert: ArticleVO = mappingArticle['EmptyZone'];
      const targetPin: any = projectConnection['target-pin'];
      let startOffset: number = 0;
      const maxLength: number = this.maxLength;
      if (maxLength !== 0) {
        startOffset = Number(targetPin.offset * 10);
      } else {
        startOffset = Number(targetPin.offset * 10);
      }
      try {
        const data = await this.blockingZoneManager.insertZoneArticle(articleToInsert, this.mountingRailArticleUsage, (targetPin.length * 10), startOffset, true, false, 'importProServeProjectProcess');
        await this.importProServeProjectProcess_success(data);
      } catch (error) {
        Log.error('Could not load zone article: ', error)
        await this.articleNOTProjected();
      }
    }
  }

  private async continueArticleContainerAttached(projectConnectionAccessory: string): Promise<void> {
    if (projectConnectionAccessory) {
      this.projectConnectionCounterAcessories++;
      const mappingArticleNumber: string[] = this.mappingArticleNo;
      if (projectConnectionAccessory['base-pin']) {
        const basePin: any = projectConnectionAccessory['base-pin'];
        const targetPin: any = projectConnectionAccessory['target-pin'];
        const getBasePinArticleNo = mappingArticleNumber[basePin.projectArticleID];
        const getTargetPinArticleNo = mappingArticleNumber[targetPin.projectArticleID];
        this.projectArticleID = basePin.projectArticleID;
        this.articleNo = getBasePinArticleNo;
        const mappingArticle: ArticleVO[] = this.mappingArticleArray;
        const article: ArticleVO = mappingArticle[getTargetPinArticleNo];
        const targetIsMountingRail: boolean = ArticleUtils.isMountingRail(article);
        let alternativeTargetConnectionOrder: number = NaN;
        let basePinArticleArticle: ArticleVO = null;
        let currentBasePin: any = null;
        let currentTargetPin: any = null;
        if (!targetIsMountingRail && article) {
          this.projectArticleIdToRailPosData[basePin.projectArticleID] = this.projectArticleIdToRailPosData[targetPin.projectArticleID];
          const getProductionConnectionWithSameArticleID: any = this.productionConnectionWithSameArticleID;
          const productionArticles: string[] = getProductionConnectionWithSameArticleID[basePin.projectArticleID];
          let targetConnectionCubes: Connection[] = [];
          let baseConnections: ConnectionAreaVO[] = [];
          const targetsOfCurrentBase: string[] = [];
          const targetsOfCurrentBaseOrder: string[] = [];
          let targetOrderNumber: string = '0';
          const toDeleteLabel: number[] = [];
          const sortedProductionArticles: any[] = ProServeProjectImportUtils.sortSameProductionConnection(
            productionArticles,
            getProductionConnectionWithSameArticleID
          );
          const reverseSorted: string[] = sortedProductionArticles.reverse();
          const railPosArray: string[] = [];
          if (!reverseSorted || reverseSorted.length <= 1) {
            this.projectArticleIdToRailPosData[basePin.projectArticleID] = this.projectArticleIdToRailPosData[targetPin.projectArticleID];
          } else {
            this.projectArticleIdToRailPosData[basePin.projectArticleID] = railPosArray;
          }
          for (let z: number = 0; z < reverseSorted.length; z++) {
            const productionArticle: string = reverseSorted[z];
            currentBasePin = productionArticle['base-pin'];
            currentTargetPin = productionArticle['target-pin'];
            railPosArray.push(this.projectArticleIdToRailPosData[currentTargetPin.projectArticleID]);
            targetsOfCurrentBase.push(currentTargetPin.projectArticleID);
            const currentBasePinArticleNo = mappingArticleNumber[currentBasePin.projectArticleID];
            const currentTargetPinArticleNo = mappingArticleNumber[currentTargetPin.projectArticleID];
            const targetarticle: ArticleVO = mappingArticle[currentTargetPinArticleNo];
            // check if its end plate and delete it, beacause it has no connection for Label
            if (ArticleUtils.isEndPlateArticleType(targetarticle.type.displayName)) {
              toDeleteLabel.push(z + 1);
              continue;
            }
            const targetPinArticle: ArticleVO = mappingArticle[currentTargetPinArticleNo];
            basePinArticleArticle = mappingArticle[currentBasePinArticleNo];
            this.projectArticleID = currentBasePin.projectArticleID;
            this.articleNo = currentBasePinArticleNo;
            targetOrderNumber = currentTargetPin.order;
            if (basePinArticleArticle && targetPinArticle) {
              // target is for example terminal block
              // base is for example accessory/label article
              const targetConnectionOrder: string = currentTargetPin.order;
              const baseConnectionOrder: number = parseInt(currentBasePin.order, 10);
              const basePole: number = parseInt(currentBasePin.pole, 10);
              const targetMetaElements: MetaElementVO[] = targetPinArticle.metaElements;
              const baseMetaElements: MetaElementVO[] = basePinArticleArticle.metaElements;
              let targetMetaElementName: string = ProServeProjectImportUtils.getMetaElementName(targetMetaElements, targetConnectionOrder);
              if (targetMetaElementName === '') {
                const connectionOrderNumber: number = Number(targetConnectionOrder);
                alternativeTargetConnectionOrder = ProServeProjectImportUtils.getAlternativeOrderConnection(
                  connectionOrderNumber,
                  currentTargetPinArticleNo,
                  this.alternativeorderNumbers
                );
                targetMetaElementName = ProServeProjectImportUtils.getMetaElementName(targetMetaElements, String(alternativeTargetConnectionOrder));
              }
              targetsOfCurrentBaseOrder.push(targetMetaElementName);
              let baseConnection: ConnectionAreaVO = ProServeProjectImportUtils.getGivingConnectionVo(
                baseMetaElements,
                baseConnectionOrder,
                basePole
              );
              if (!baseConnection) {
                alternativeTargetConnectionOrder = ProServeProjectImportUtils.getAlternativeOrderConnection(
                  baseConnectionOrder,
                  currentBasePinArticleNo,
                  this.alternativeorderNumbers
                );
                baseConnection = ProServeProjectImportUtils.getGivingConnectionVo(baseMetaElements, alternativeTargetConnectionOrder, basePole);
              }
              let targetArticleUsage: ArticleUsageVO = null;
              if (this.projectArticleIdToArticleUsage[currentTargetPin.projectArticleID]) {
                targetArticleUsage = this.projectArticleIdToArticleUsage[currentTargetPin.projectArticleID];
              } else if (this.projectArticleIdToLabelUsage[currentTargetPin.projectArticleID]) {
                targetArticleUsage = this.projectArticleIdToLabelUsage[currentTargetPin.projectArticleID];
              }
              if (targetArticleUsage && baseConnection) {
                const targetMetaElementUsageIdenty: MetaElementUsageIdentityVO = MetaElementUsageIdentityVO.create(
                  targetArticleUsage.id,
                  targetMetaElementName
                );
                const targetConnectionCube: Connection = this.connectionInfoService.findConnectionByIdentity(targetMetaElementUsageIdenty);
                if (targetConnectionCube) {
                  const conn: Connection[] = ConnectionInfoUtils.filterAcceptingCubes([targetConnectionCube]);
                  // for complex article: Accessories on complex article are not allowed to occupy same position
                  if (conn.length > 0) {
                    targetConnectionCubes.push(targetConnectionCube);
                    baseConnections.push(baseConnection);
                  }
                } else {
                  targetConnectionCubes = [];
                  baseConnections = [];
                  break;
                }
              } else {
                targetConnectionCubes = [];
                baseConnections = [];
                break;
              }
            } else {
              if (ProServeProjectImportUtils.checkObjectExist(this.troubleTable, currentBasePin.projectArticleID)) {
                this.addTroubleArticle(this.currentChild[4], currentBasePinArticleNo, currentBasePin.projectArticleID);
              }
            }
          }
          // <MultiLine>
          let projectArticleIdOfAssignedLabelArticle: string = null;
          const tConnectionOrder: string = isNaN(alternativeTargetConnectionOrder) ? targetOrderNumber : alternativeTargetConnectionOrder + '';
          if (ArticleUtils.isLabelingArticle(basePinArticleArticle)) {
            if (this.targetsOfBase[targetPin.projectArticleID + '_and_target_connection_order_' + tConnectionOrder]) {
              projectArticleIdOfAssignedLabelArticle =
                this.targetsOfBase[targetPin.projectArticleID + '_and_target_connection_order_' + tConnectionOrder];
            } else {
              projectArticleIdOfAssignedLabelArticle = null;
            }
            // projectArticleIdOfAssignedLabelArticle = ProServeProjectImportUtils.assignLabeling(targetsOfCurrentBase, _targetsOfBase);
          }
          if (!projectArticleIdOfAssignedLabelArticle) {
            // target is for example terminal block
            // base is label article
            this.targetsOfBase[targetPin.projectArticleID + '_and_target_connection_order_' + tConnectionOrder] = basePin.projectArticleID;
            const labelingMaterialArray: any[] = [];
            // const currentLabelAttrributes: any[] = this._labelAttribute[basePin.projectArticleID];
            if (toDeleteLabel.length > 0 && this.labelAttribute[basePin.projectArticleID]) {
              labelingMaterialArray[targetOrderNumber] = this.labelAttribute[basePin.projectArticleID];
              this.labelingMaterialCollection[basePin.projectArticleID] = labelingMaterialArray;
              this.toDeleteLabel[currentBasePin.projectArticleID] = toDeleteLabel;
            } else {
              labelingMaterialArray[targetOrderNumber] = this.labelAttribute[basePin.projectArticleID];
              this.labelingMaterialCollection[basePin.projectArticleID] = labelingMaterialArray;
            }
          } else {
            const labelingMaterialArray: any = this.labelingMaterialCollection[projectArticleIdOfAssignedLabelArticle];
            labelingMaterialArray[targetOrderNumber] = this.labelAttribute[basePin.projectArticleID];
            this.labelingMaterialCollection[projectArticleIdOfAssignedLabelArticle] = labelingMaterialArray;
          }
          // </MultiLine>
          if ((targetConnectionCubes.length && baseConnections.length) !== 0 && !projectArticleIdOfAssignedLabelArticle) {
            this.lastRequestedInsertProjectLabelIdForLabel = basePin.projectArticleID;
            this.interceptOpenLabelEditor = true;
            const suitableGivingAreas: SuitableConnectionAreasVO = new SuitableConnectionAreasVO();
            suitableGivingAreas.article = basePinArticleArticle;
            baseConnections.sort(this.baseConnectionSortFunction);
            suitableGivingAreas.connectionAreas = baseConnections;
            await this.articleCreationManager.createArticlesBySuitableGivingConnectionAreasAndAcceptingCubes(suitableGivingAreas, ConnectionInfoUtils.sortConnectionsByPoint(targetConnectionCubes));
          } else {
            // const baseArticle: ArticleVO = mappingArticle[getBasePinArticleNo];
            if (baseConnections.length === 0 && ProServeProjectImportUtils.checkObjectExist(this.troubleTable, basePin.projectArticleID)) {
              this.addTroubleArticle(this.currentChild[4], getBasePinArticleNo, basePin.projectArticleID);
            }
          }
        } else {
          const baseArticle: ArticleVO = mappingArticle[getBasePinArticleNo];
          if (!baseArticle && ProServeProjectImportUtils.checkObjectExist(this.troubleTable, basePin.projectArticleID)) {
            this.addTroubleArticle(this.currentChild[4], getBasePinArticleNo, basePin.projectArticleID);
          }
        }
      }
    }
  }

  private async detectAlternativeOrderConnectionSuccessHandler(data: OrderConnectionInformationVO[]): Promise<void> {
    if (this.proServerModus) {
      this.alternativeorderNumbers = data;
    }
  }

  private baseConnectionSortFunction(a: ConnectionAreaVO, b: ConnectionAreaVO): number {
    const corridorA: number = a ? a.corridor : NaN;
    const corridorB: number = b ? b.corridor : NaN;
    const orderA: number = a ? a.orderNumber : NaN;
    const orderB: number = b ? b.orderNumber : NaN;
    if (NumberUtils.numericCompare(orderA, orderB) === 0) {
      return NumberUtils.numericCompare(corridorA, corridorB);
    } else {
      return NumberUtils.numericCompare(orderA, orderB);
    }
  }

  private async preProcessLabels(): Promise<void> {
    for (const item in this.projectArticleIdToLabelUsage) {
      if (item) {
        if (this.projectArticleIdToLabelUsage.hasOwnProperty(item)) {
          const articleUsage: ArticleUsageVO = this.projectArticleIdToLabelUsage[item];
          if (!articleUsage) {
            continue;
          }
          const articleContainer: ArticleContainer = this.containerService.findArticleContainerInGlobal(articleUsage.id);
          const currentLabels: any[] = this.labelingMaterialCollection[item];
          const textureAreaUsages: TextureAreaUsageVO[] = ArticleUsageUtils.textureAreaUsages(articleUsage);
          const sortedTextureAreaUsages: TextureAreaUsageVO[] = this.getSortedTextureAreaUsages(textureAreaUsages, articleContainer);
          ProServeProjectImportUtils.preProcessLabel(
            currentLabels,
            sortedTextureAreaUsages,
            this.toDeleteLabel[item],
            this.globalToDeleteLabel,
            this.projectArticleIdToRailPosData,
            this.railPosToTextCheckSpacingData
          );
          if (!articleContainer) {
            continue;
          }
          articleContainer.refreshTextureConnections();
        }
      }
    }
  }

  private getSortedTextureAreaUsages(textureAreaUsages: TextureAreaUsageVO[], articleContainer: ArticleContainer): TextureAreaUsageVO[] {
    let sortedTextureAreaUsages: TextureAreaUsageVO[] = [];
    if (
      textureAreaUsages &&
      articleContainer &&
      articleContainer.textConnections &&
      articleContainer.textConnections.length === textureAreaUsages.length
    ) {
      let sortIndex: number = 0;
      const textConnections: TextureConnectionInfo[] = articleContainer.textConnections;
      while (sortIndex < textConnections.length) {
        const con: TextureConnectionInfo = textConnections[sortIndex];
        if (con) {
          for (const textureAreaUsage of textureAreaUsages) {
            if (textureAreaUsage && textureAreaUsage.identity && textureAreaUsage.identity.metaElementName === con.id) {
              sortedTextureAreaUsages.push(textureAreaUsage);
            }
          }
        }
        sortIndex++;
      }
    } else {
      sortedTextureAreaUsages = textureAreaUsages;
    }
    return sortedTextureAreaUsages;
  }

  private async startBlockingZoneInserted(data: InsertedArticleData): Promise<void> {
    const createdContainer: ArticleContainer = this.containerService.findArticleContainerInGlobal(data.insertedArticleGUIDs[0]);
    ArticleUsageUtils.setArticleUsageInfoPropertyStringValue(createdContainer.articleUsage, ArticleUsageInfoPropertyDef.BLOCKING_ZONE_TYPE, ArticleConstants.BLOCKING_ZONE_TYPE_START);
    await this.insertBlockingZone(false);
  }

  private async startBlockingZoneFailure(): Promise<void> {
    await this.insertBlockingZone(false);
  }

  private async endBlockingZoneFailure(): Promise<void> {
    await this.findTargetMetaElements();
  }

  private async endBlockingZoneInserted(data:InsertedArticleData): Promise<void> {
    const createdContainer: ArticleContainer = this.containerService.findArticleContainerInGlobal(data.insertedArticleGUIDs[0]);
    ArticleUsageUtils.setArticleUsageInfoPropertyStringValue(createdContainer.articleUsage, ArticleUsageInfoPropertyDef.BLOCKING_ZONE_TYPE, ArticleConstants.BLOCKING_ZONE_TYPE_END);
    await this.findTargetMetaElements();
  }


  private subscribeOnAddedArticles(): void {
    this._addedArticlesSubscription = this.articleCreationService.articlesAdded$.subscribe({
      next: async (data) => {
        if (data.type !== 'articlesAdded') {
          return;
        }
        data.success ? await this.accessoriesProjected() : await this.accessoryArticleInsertFailed();
      },
      error: (error) => Log.error('Error in added articles subscription: ', error)
    })
  }

  private async accessoriesProjected(): Promise<void> {
    if (this.proServerModus) {
      const articleUsages: ArticleUsageVO[] = this.articleCreationManager.getCreatedArticleUsages();
      const articleUsage: ArticleUsageVO = articleUsages[0];
      if (articleUsage) {
        this.projectArticleIdToLabelUsage[this.lastRequestedInsertProjectLabelIdForLabel] = articleUsage;
      } else {
        if (ProServeProjectImportUtils.checkObjectExist(this.troubleTable, this.projectArticleID)) {
          this.addTroubleArticle(this.currentChild[4], this.articleNo, this.projectArticleID);
        }
      }
    }
    if (this.articleCreationManager) {
      this.articleCreationManager.clean();
    }
  }

  private async setLabels(): Promise<void> {
    for (const item in this.projectArticleIdToLabelUsage) {
      if (this.projectArticleIdToLabelUsage.hasOwnProperty(item)) {
        const articleUsage: ArticleUsageVO = this.projectArticleIdToLabelUsage[item];
        let articleInformationFromXML: any = null;
        let articleLength: number = 0;
        if (this.tagsByProjectArticleId[item]) {
          articleInformationFromXML = this.tagsByProjectArticleId[item];
          articleLength = parseFloat(articleInformationFromXML.length);
        }
        const parentUsageIds: string[] = ArticleUsageUtils.getBackwardConnectedArticleUsageIds(articleUsage);
        const parentArticleUsage: ArticleUsageVO = parentUsageIds.length >= 1 ? this.projectModel.getArticleUsage(parentUsageIds[0]) : null;
        if (!articleUsage) {
          continue;
        }
        const article: ArticleVO = this.articleManager.getCachedArticle(articleUsage.articleId, articleUsage.articleVersion);
        const parentArticle: ArticleVO = !parentArticleUsage
          ? article
          : this.articleManager.getCachedArticle(parentArticleUsage.articleId, parentArticleUsage.articleVersion);
        const spacingData: TextCheckSpacingData = LabelingUtils.getTextCheckSpacingDataByTerminalArticle(parentArticle);
        const isMarkerCarrier: boolean = ArticleUtils.isArticleOfType(parentArticle, ArticleTypeConstants.TYPE_MARKER_CARRIER);
        let textSizeCheckClass: string = '';
        for (const metaElementVO of article.metaElements) {
          if (metaElementVO instanceof TextureAreaVO) {
            textSizeCheckClass = PropertyUtils.getStringPropertyValue(
              metaElementVO.behaviorProperties,
              MetaElementBehaviorPropertyDef.TEXT_CHECK_CLASS
            );
          }
        }
        const articleContainer: ArticleContainer = this.containerService.findArticleContainerInGlobal(articleUsage.id);
        const currentLabels: any[] = this.labelingMaterialCollection[item];
        const rotated: boolean = ProServeProjectImportUtils.getRotationByPath(item, this.productionConnectionWithSameArticleID);
        const textureAreaUsages: TextureAreaUsageVO[] = ArticleUsageUtils.textureAreaUsages(articleUsage);
        const sortedTextureAreaUsages: TextureAreaUsageVO[] = this.getSortedTextureAreaUsages(textureAreaUsages, articleContainer);
        let textsizeCheckFound: boolean = true;
        if (ProServeProjectImportUtils.dictionaryLength(currentLabels) > 1) {
          textsizeCheckFound = ProServeProjectImportUtils.setLabelForMultiLine(
            currentLabels,
            sortedTextureAreaUsages,
            this.toDeleteLabel[item],
            this.globalToDeleteLabel,
            this.textSizeCheckManager,
            spacingData,
            textSizeCheckClass,
            articleLength,
            rotated,
            isMarkerCarrier
          );
        } else if (ProServeProjectImportUtils.dictionaryLength(currentLabels) === 1) {
          textsizeCheckFound = ProServeProjectImportUtils.setLabelWithOneLine(
            currentLabels,
            sortedTextureAreaUsages,
            this.toDeleteLabel[item],
            this.globalToDeleteLabel,
            this.textSizeCheckManager,
            spacingData,
            textSizeCheckClass,
            articleLength,
            rotated
          );
        }
        if (!textsizeCheckFound) {
          this.addTroubleArticle(this.currentChild[4], this.localeResourceManager.getValueByKey('validation.error.no_valid_config'), item);
        }
        if (!articleContainer) {
          continue;
        }
        articleContainer.refreshMetaElements();
        articleContainer.refreshContainer(false);
        articleContainer.refreshTextureConnections();
      }
    }
    await this.projectLoadingComplete();
  }

  private async clear(): Promise<void> {
    await this.projectModelService.clearCurrentProject(true);
    this.articleObject3DManager.clearAllCaches();
    this.articleCreationManager.clean();
    this.proServerModus = false;
    this.labelAttribute = [];
    this.targetsOfBase = [];
    this.mountingRailArticle = null;
    this.mountingRailArticleUsage = null;
    this.projectArticleIdToArticleUsage = [];
    this.interceptOpenLabelEditor = false;
    this.projectArticleIdToLabelUsage = [];
    this.toDeleteLabel = [];
    this.globalToDeleteLabel = [];
    this.projectArticleIdToRailPosData = [];
    this.railPosToTextCheckSpacingData = [];
    this.projectModel.ignoreSplitConnectionCubes = false;
    this.projectModel.texturesEnabled = true;
    this.projectelementsData = new Object();
    this.projectSummary = new Dictionary();
    this.currentProjectArticleArray = [];
    this._initialized = false;
    this.articlesForOneProject = [];
    this.holes = [];
    this.xmltoArray = [];
    this.productionConnectionWithSameArticleID = [];
    this.productionConnection = [];
    this.labelingMaterialCollection = [];
    this.convertedmappedArticleNoArrayToDictionary = [];
    this.mappingArticleNo = [];
    this.projectMetaData = new Dictionary();
    this.lastRequestedInsertProjectLabelIdForLabel = null;
    this.projectToGroupMapping = new Dictionary<string, ProjectGroupVO>();
  }

  private clearForNextCarrier(): void {
    this.currentProjectArticleArray = [];
    this.labelAttribute = [];
    this.targetsOfBase = [];
    this.mountingRailArticle = null;
    this.mountingRailArticleUsage = null;
    this.projectArticleIdToArticleUsage = [];
    this.projectArticleIdToLabelUsage = [];
    this.toDeleteLabel = [];
    this.globalToDeleteLabel = [];
    this.projectArticleIdToRailPosData = [];
    this.railPosToTextCheckSpacingData = [];
    this.projectelementsData = new Object();
    this.articlesForOneProject = [];
    this.holes = [];
    this.xmltoArray = [];
    this.productionConnectionWithSameArticleID = [];
    this.productionConnection = [];
    this.labelingMaterialCollection = [];
    this.convertedmappedArticleNoArrayToDictionary = [];
    this.mappingArticleNo = [];
    this.projectMetaData = new Dictionary();
    this.lastRequestedInsertProjectLabelIdForLabel = null;
  }

  private async projectLoadingComplete(): Promise<void> {
    if (!this.proServerModus) {
      return;
    }
    const level: number = ProServeProjectImportUtils.dictionaryLength(this.currentChild[3]);
    if (this.parentProjectGroup.id > 0) {
      try {
        const projectGroup = await this.projectGroupLoadingService.loadProjectGroupById(this.parentProjectGroup.id, (level + 1));
        await this.groupByIdLoaded_success(projectGroup);
      } catch (error) {
        Log.info('Could not load projectgroup by id: ', error)
      }
    } else {
      try {
        const baseGroups = await firstValueFrom(this.projectGroupDataService.loadOwnedBaseProjectGroups(level + 1));
        await this.baseGroupsListed_success(baseGroups);
      } catch (error) {
        Log.info('Could not load base projectgroups: ', error)
      }
    }
  }

  private async groupByIdLoaded_success(projectGroup: ProjectGroupVO): Promise<void> {
    if (this.proServerModus) {
      await this.saveProject(projectGroup);
    }
  }

  private async baseGroupsListed_success(baseGroups: ProjectGroupVO[]): Promise<void> {
    if (!this.proServerModus) {
      return;
    }
    const projectParent: any = this.currentChild[3];
    for (const key in baseGroups) {
      if (baseGroups.hasOwnProperty(key)) {
        const currentProjectGroup: ProjectGroupVO = baseGroups[key];
        if (currentProjectGroup.groupName === projectParent['ProjectGroup']) {
          await this.saveProject(currentProjectGroup);
          break;
        }
      }
    }
  }

  private async saveProject(groupProjectGroup: ProjectGroupVO): Promise<void> {
    const currentProjectGroup: ProjectGroupVO = groupProjectGroup;
    let configName: string = this.carrierName;
    const firstParent: ProjectGroupVO = this.currentChild[1];
    const projectGroupWithID: ProjectGroupVO = ProServeProjectImportUtils.findParentGroupByGroupNameAndGroupType(
      currentProjectGroup,
      firstParent.groupName,
      ProjectGroupUtils.PROJECT
    );
    configName = configName.trim();
    configName = ProServeProjectImportUtils.checkProjectNameExist(projectGroupWithID, configName);
    this.projectModel.currentProject.guid = StringUtils.createUuid();
    this.projectModel.currentProject.name = configName;
    const currentProjectOptions: ProjectOptionVO[] = ProServeProjectImportUtils.setProjectMetaElement(this.projectUserModel.projectOptionDefs, this.projectMetaData);
    this.projectModel.currentProject.options = currentProjectOptions;
    ProjectUtils.setInitialVersionDisplayString(this.projectModel.currentProject, this.projectUserModel.projectOptionDefs);
    this.projectModel.currentProject.projectGroup = projectGroupWithID ? projectGroupWithID : null;

    this.projectModel.currentProject.drawingNumber = !StringUtils.isEmpty(
      ProServeProjectImportUtils.getProjectMetaElementValue(this.projectMetaData, 'OrderData', 'SignNo')
    )
      ? ProServeProjectImportUtils.getProjectMetaElementValue(this.projectMetaData, 'OrderData', 'SignNo')
      : null;

    this.projectModel.currentProject.articleNumber = !StringUtils.isEmpty(
      ProServeProjectImportUtils.getProjectMetaElementValue(this.projectMetaData, 'OrderData', 'ItemNo')
    )
      ? ProServeProjectImportUtils.getProjectMetaElementValue(this.projectMetaData, 'OrderData', 'ItemNo')
      : null;

    this.projectModel.currentProject.articleNumberLong = new ArticleNumberLong(!StringUtils.isEmpty(
      ProServeProjectImportUtils.getProjectMetaElementValue(this.projectMetaData, 'OrderData', 'LongArticleNo')
    )
      ? ProServeProjectImportUtils.getProjectMetaElementValue(this.projectMetaData, 'OrderData', 'LongArticleNo')
      : null);

    this.projectModel.currentProject.isArticleNumberGenerated = false;

    const result = await this.saveProjectService.saveConfiguration(-1, this.projectModel.currentProject, false, InitManager.PROJECT_OPTION_DATA_VERSION, 'current', true);
    if (result) {
      await this.projectSaved_success();
    } else {
      await this.projectSaved_Fail();
    }
  }

  private async projectSaved_success(): Promise<void> {
    this.proServerModus = false;
    this.projectModel.ignoreSplitConnectionCubes = false;
    this.projectModel.texturesEnabled = true;
    await this.proceedToNextCarrier();
  }

  private async projectSaved_Fail(): Promise<void> {
    if (this.carrierNo) {
      this.projectSummary.setValue(this.currentChild[4], 0);
      this.proServerModus = false;
      this.projectModel.ignoreSplitConnectionCubes = false;
      this.projectModel.texturesEnabled = true;
      await this.proceedToNextCarrier();
    }
  }

  public interceptOpenLabelEditorEvent(data: LabelEditorData): boolean {
    this.ensureInitialized();

    if (!this.proServerModus || !this.interceptOpenLabelEditor) return true;

    if (data?.connectionCubes) {
      for (const connection of data.connectionCubes) {
        LabelingUtils.applyTextureMetaElementUsageIfNotExists(connection, this.projectArticleService, this.projectMetaElementService);
      }
    }
    return false;
  }

  private async accessoryArticleInsertFailed(): Promise<void> {
    if (this.proServerModus) {
      if (ProServeProjectImportUtils.checkObjectExist(this.troubleTable, this.projectArticleID)) {
        this.addTroubleArticle(this.currentChild[4], this.articleNo, this.projectArticleID);
      }
    }
  }

  private showWaitImportPopup(): void {
    if (!this._waitImportPopupShown) {
      this._waitImportPopupShown = true;
      this.waitForImportPopupRef = this.projectComponentPresenter.openWaitForImportPopup();
    }
  }

  private closeWaitImportPopup(): void {
    if (this._waitImportPopupShown) {
      this._waitImportPopupShown = false;
      this.waitForImportPopupRef.hide();
    }
  }

  public async articleNOTProjected(): Promise<void> {
    this.ensureInitialized();
    if (this.proServerModus) {
      this.addTroubleArticle(this.currentChild[4], this.articleNo, this.projectArticleID);
    }
  }

  // Return whether this method has to intercept (MessageInterceptor) or not.
  public async connectArticle_failure(): Promise<boolean> {
    this.ensureInitialized();
    if (!this.proServerModus) return false;

    if (ProServeProjectImportUtils.checkObjectExist(this.troubleTable, this.projectArticleID)) {
      this.addTroubleArticle(this.currentChild[4], this.articleNo, this.projectArticleID);
    }

    return true;
  }

  private ensureInitialized() {
    if (!this._processorInitialized) {
      throw new Error("ProServeProjectImportProcessor not initialized!")
    }
  }
}
